import { pageTitle$ } from "src/framework/store/ApiEvents";
import "./style.css";

const Home = () => {

  pageTitle$.next("")
  return (
    <div>
      <h1>Bem vindo</h1>
    </div>
  );
};

export { Home };
